
<template>
  <!--举报记录-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="memberId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
      <template slot="opt_h" slot-scope="{row}">
        <a-tooltip :title="row.content">
          <div class="feed-over-text" @click="showDetail(row.content)">{{row.content}}</div>
        </a-tooltip>
      </template>
      <template slot="opt_btn" slot-scope="{row}">
        <a-button type="link" @click="toDetail(row)">详情</a-button>
        <div role="separator" class="ant-divider ant-divider-vertical"></div>
        <a-button type="link" @click="toAudit(row.reportLogId)" :disabled="row.status != 0">处理</a-button>
      </template>
      <template slot="opt_id" slot-scope="{row}">
        <a-button type="link" @click="toActivity(row.activityId)">{{row.activityId}}</a-button>
      </template>
      <template slot="opt_titles" slot-scope="{row}">
        <a-button type="link" @click="toActivity(row.activityId)">{{row.title}}</a-button>
      </template>
    </x-tabula>
    <a-modal v-model="visible" title="举报记录详情" width="700px">
      <div class="box">
        <ul class=" box_ul">
          <li><span>账号：</span><div>{{detailData.mobilePhone}}</div></li>
          <li><span>昵称：</span><div>{{detailData.nickName}}</div></li>
          <li><span>举报时间：</span><div>{{detailData.createTime}}</div></li>
          <li><span>活动ID：</span><div>{{detailData.activityId}}</div></li>
          <li><span>活动标题：</span><div>{{detailData.title}}</div></li>
          <li><span>举报理由：</span><div>{{detailData.content}}</div></li>
          <li><span>处理结果：</span><div>{{detailData.statusDesc}}</div></li>
          <li><span>处理意见：</span><div>{{detailData.remark}}</div></li>
        </ul>
      </div>
       <template slot="footer">
        <a-button @click="visible = false">关闭</a-button>
      </template>
    </a-modal>

    <!--订单处理的弹窗-->
    <a-modal
      title="处理"
      :visible="showAudit"
      @cancel="showAudit=false"
      @ok="$refs.addEdit.handleSubmit()"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      :width="650"
    >
      <x-addEdit
        ref="addEdit"
        modalType="modal"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      />
    </a-modal>

    <!--举报内容的弹窗-->
    <a-modal
      title="举报理由"
      :visible="reportVisible"
      @cancel="reportVisible=false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="900"
    >
      <div>{{reportContent}}</div>
    </a-modal>

  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'ReportRecord',
  data () {
    return {
      reportVisible: false,
      reportContent: '',
      auditId: '',
      showAudit: false,
      btnLoading: { loading: false },
      defaultCheckedKeys: [],
      // 表单参数
      addParam: {
        url: '',
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },
      editParam: {
        url: '/activity/report/log/',
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },
      detailParam: {
        url: '',
        resHandle: ''
      },
      formKey: {
        remark: 'asdsdf',
        status: ''
      },
      formList: [
        {
          label: '处理方式',
          inputType: 'radioGroup',
          options: [{label: '处理', value: 1}, {label: '忽略', value: 2}],
          placeholder: '',
          handle: (e) => {
            // if (e.target.value == 2) {
            //   this.formList[1].isShow = false;
            // } else {
            //   this.formList[1].isShow = true;
            // }
          },
          props: ['status', {
            rules: [
              { required: true, message: '请选择处理方式' }
            ],
            initialValue: 1
          }]
        },
        {
          label: '处理意见',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入处理意见',
          isShow: true,
          props: ['remark', {
            rules: [{
              required: true, min: 5, message: '请输入处理意见,最少5个字符'
            }]
          }]
        }
      ],
      detailData: {},
      visible: false,
      balance: '',
      currentRow: {},
      searchList: [
        { props: ['mobilePhone'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['keywords'], placeholder: '活动ID/活动标题', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: [{label: '未处理', value: 0}, {label: '已处理', value: 1}, {label: '已忽略', value: 2}], inputType: 'select' }
      ],
      searchParams: {
        mobilePhone: undefined,
        keywords: undefined,
        status: undefined
      },
      tableOptList: [],
      rowOptList: [
        {
          text: '详情',
          handle: (row) => this.toDetail(row),
          permi: ['community:activityReport:query']
        },
        {
          text: '处理',
          handle: (row) => this.toAudit(row.reportLogId),
          rowOptDisHandle: row => this.optBtnDisable(row),
          permi: ['community:activityReport:handle']
        }
      ],
      columns: [
        { title: '昵称', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobilePhone', align: 'left', width: '' },
        { title: '活动ID', dataIndex: 'activityId', align: 'left', width: '', scopedSlots: {customRender: 'id'} },
        { title: '活动标题', dataIndex: 'title', align: 'left', width: '', scopedSlots: {customRender: 'titles'}},
        { title: '举报理由', dataIndex: 'content', align: 'left', width: '', scopedSlots: {customRender: 'h'}},
        { title: '举报时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '处理结果', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
        // { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'btn'} }
      ],
      dataSource: [],
      listApi: {
        url: '/activity/report/log/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    optBtnDisable (row) {
      if (row.status != 0) {
        return true;
      }
    },
    // 活动详情
    toActivity (id) {
      this.$router.push({
        name: 'activityDetail',
        query: { id: id }
      });
    },
    /* 查看回复内容 */
    showDetail (content) {
      this.reportContent = content;
      this.reportVisible = true;
    },
    // 处理
    reqHandle (res) {
      this.$put({
        url: '/activity/report/log/' + this.auditId,
        params: {
          ...res
        }
      }).then(({ data }) => {
        this.$message.success('处理成功');
        this.showAudit = false;
        this.$refs.table.getTableList();
      });
    },

    /* 获取下拉 */
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      let paramArr = [
        {index: 3, scope: 'searchList', query: 'comu_member_register_type'},
        {index: 4, scope: 'searchList', query: 'comu_member_register_platform'}
      ];
      this.dictionarySelect(paramArr);
    },
    /* 查看详情 */
    toDetail (row) {
      this.detailData = row;
      this.visible = true;
    },
    toAudit (id) {
      // this.$refs.form.routeQuery = id;
      this.auditId = id;
      this.addParam.url = '/activity/report/log/' + id;
      this.showAudit = true;
    },

    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>

<style lang="less" scoped>
.box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  vertical-align: middle;
}
.box_ul{
  list-style: none;
  width:100%;
  li{
    line-height: 45px;
    width:100%;
    span{
      display: inline-block;
      width:30%;
      text-align: right;
      vertical-align: top;
    }
    div{display: inline-block;
      width:60%;
      clear:both;
    }
  }
}
</style>
